import { render, staticRenderFns } from "./Boards.vue?vue&type=template&id=c3f112da"
import script from "./Boards.vue?vue&type=script&lang=js"
export * from "./Boards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports